import React, { useState,useRef,useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Grid,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const EASUPGSTFeatureSection = () => {
  const servicesRef = useRef(null);
  const [services, setServices] = useState([]);

  const handleScrollToServices = () => {
    servicesRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const fetchServices = async () => {
    try {
     const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/Service/GetAllServices`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

      const data = res.data?.data || [];
      setServices(data);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          py: 8,
          px: 3,
          backgroundImage: 'url("Images/gst.png")',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgb(255 255 255 / 95%)',
            zIndex: 1,
          },
          '& > *': {
            position: 'relative',
            zIndex: 2,
          },
        }}
      >
        <Grid container spacing={6} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{
                mb: 3,
                color: '#004080',
                fontFamily: "'Poppins', sans-serif",
                lineHeight: 1.4,
              }}
            >
              Everything you need to manage
              <br />
              GST filing and billing
            </Typography>

            <Stack spacing={2} sx={{ mb: 4 }}>
              {[
                'Automated GST return filing',
                'Invoice generation & tracking',
                'Minimized human errors with expert oversight',
                'Consultants track every change in GST law',
                'Notices & compliance alerts handled for you',
              ].map((text, i) => (
                <Box key={i} display="flex" alignItems="center">
                  <CheckCircleIcon sx={{ color: '#00c58d', mr: 1 }} />
                  <Typography variant="body1">{text}</Typography>
                </Box>
              ))}
            </Stack>

            <Button
              onClick={handleScrollToServices}
              variant="contained"
              sx={{
                background: 'linear-gradient(90deg, #003366 0%, #004080 50%, #0059b3 100%)',
                color: '#ffffff',
                borderRadius: 2,
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: '1rem',
                '&:hover': {
                  background: 'linear-gradient(90deg, #002b55 0%, #003f73 50%, #004c99 100%)',
                },
                mb: 2,
              }}
            >
              Services
            </Button>
          </Grid>

          <Grid item xs={12} md={6} position="relative">
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                maxWidth: 500,
                mx: 'auto',
              }}
            >

              <Box
                component="img"
                src="Images/gst.png"
                alt="EASUP GST Dashboard"
                sx={{
                  width: '100%',
                  borderRadius: 4,
                  boxShadow: 3,
                }}
              />

              <Box
                component="img"
                src="Images/gst.png"
                alt="Invoice Icon"
                sx={{
                  position: 'absolute',
                  top: '10%',
                  right: '-10%',
                  width: 100,
                  height: 150,
                  borderRadius: 3,
                  boxShadow: 3,
                  border: '4px solid white',
                }}
              />

              <Box
                sx={{
                  position: 'absolute',
                  bottom: '10%',
                  left: '-10%',
                  backgroundColor: '#fff',
                  borderRadius: 2,
                  boxShadow: 3,
                  p: 1.5,
                  minWidth: 100,
                  textAlign: 'center',
                }}
              >
                <Typography variant="h6" color="#00c58d" fontWeight="bold">
                  Expert-Led
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  GST Monitoring
                </Typography>
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  bottom: '35%',
                  right: '-15%',
                  backgroundColor: '#fff',
                  borderRadius: 2,
                  boxShadow: 3,
                  p: 1.5,
                  minWidth: 100,
                  textAlign: 'center',
                }}
              >
                <Typography variant="h6" color="#00c58d" fontWeight="bold">
                  Error-Free
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Invoicing
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      
      <Box
        ref={servicesRef}
        sx={{
          py: 6,
          px: 3,
          background: 'linear-gradient(175deg, #012344 0%, #003366 100%)',
        }}
      >
        <Typography
          variant="h4"
          align="center"
          fontWeight="bold"
          sx={{
            mb: 3,
            color: '#ffffff',
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          Our Services
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{
            mb: 5,
            color: '#d0e6ff',
            maxWidth: 700,
            mx: 'auto',
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          We provide a complete set of GST & billing services to help you stay compliant and focus on growing your business.
        </Typography>

        {/* Dynamic Service Cards */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 2,
            maxWidth: '1200px',
            mx: 'auto',
          }}
        >
          {services.map((service, index) => (
            <Box
              key={service._id}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: 2,
                p: 3,
                flex: '1 1 calc(25% - 16px)',
                minWidth: '240px',
                minHeight: 180,
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
                },
              }}
            >
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  backgroundColor: '#00c58d',
                  borderRadius: '6px',
                  mb: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#ffffff',
                  fontSize: 16,
                  fontWeight: 'bold',
                }}
              >
                {index + 1}
              </Box>

              <Typography variant="subtitle1" color="#ffffff" fontWeight="bold" gutterBottom>
                {service.ServiceName}
              </Typography>
              <Typography variant="body2" color="#e0f7ff">
                {service.ServiceDescription}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default EASUPGSTFeatureSection;


